// JS específico para single

document.addEventListener('DOMContentLoaded', function() {
    // Social sharing
    const shareUrl = encodeURIComponent(window.location.href);
    const shareTitle = encodeURIComponent(document.title);

    // WhatsApp
    const whatsappLink = document.querySelector('.social-share__link[aria-label="Compartir en WhatsApp"]');
    if (whatsappLink) {
        whatsappLink.href = `https://wa.me/?text=${shareTitle}%20${shareUrl}`;
        whatsappLink.target = '_blank';
    }

    // Facebook
    const facebookLink = document.querySelector('.social-share__link[aria-label="Compartir en Facebook"]');
    if (facebookLink) {
        facebookLink.href = `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`;
        facebookLink.target = '_blank';
    }

    // Copy link
    const copyButton = document.querySelector('.social-share__copy-link');
    if (copyButton) {
        copyButton.addEventListener('click', function() {
            navigator.clipboard.writeText(window.location.href).then(function() {
                alert('Enlace copiado al portapapeles');
            }).catch(function(err) {
                console.error('Error al copiar: ', err);
            });
        });
    }
});